import { maxLengthValidation, requiredWithMaxLengthValidation } from '@/global/validators';
import { Audience } from '@/models/audiences';
import { DataSource } from '@/models/dataSource';
import { DistributionChannelConnector, DistributionChannelContent } from '@/models/distributionChannels';
import { z } from 'zod';

export const CREATE_CAMPAIGN_FORM_SCHEMA = z.object({
  name: requiredWithMaxLengthValidation(300),
  description: maxLengthValidation(3000),
  createdDataSources: z.custom<Partial<DataSource>>().array(),
  connectors: z
    .object({
      connector: z.custom<DistributionChannelConnector>(),
      distributionChannelContent: z.custom<DistributionChannelContent>(),
    })
    .array(),
  audience: z.custom<Audience>(),
});

export type CreateCampaignFormInput = z.input<typeof CREATE_CAMPAIGN_FORM_SCHEMA>;
export type CreateCampaignFormOutput = z.output<typeof CREATE_CAMPAIGN_FORM_SCHEMA>;
